import { ValidationResult } from './validation-result';

export interface CaseDocument {
	id: number | null;
	caseId: number;
	documentName: string;
	documentType: string;
	documentCategoryId: number;
	readFlag: number;
	documentPath: string;
	dateAdded: Date;
	addedBy: string;
}

export class CaseDocument {
	constructor() {
		this.id = 0;
		this.documentType = '';
		this.documentPath = '';
	}

	validateRecord(): ValidationResult {
		const vr: ValidationResult = new ValidationResult();

		if (!this.documentType || this.documentType.length === 0) {
			vr.focus_field = 'documentType';
			vr.error = 'Error: a description / type is required';
			return vr;
		}
		return vr;
	}
}
